import { MarketingConfig } from "@/types";

export const marketingConfig: MarketingConfig = {
  mainNav: [
    {
      title: "blog",
      href: "/blog",
    },
    {
      title: "generator-styles",
      href: "/generator-styles",
    },
    {
      title: "pricing",
      href: "/pricing",
    },
  ],
}